export default __webpack_public_path__ + "static/media/300-250.9e794145.png";